<div class="space-y-2">
  <div class="border border-gray-400 overflow-hidden" style="height: 210px; width: 100%;">
    <video autoplay loop muted playsinline width="100%" height="auto" class="object-contain">
      <source src="/videos/edit.mp4" type="video/mp4" />
    </video>
  </div>
  <div>Click the "Edit" button under a frame or double-click it to modify dimensions.</div>
</div>
